export default {
    crop: {
        title: 'Crop',
        cropSize: 'Crop Size',
        zoom: 'Zoom',
        custom: 'Custom',
        post: 'Post',
        square: 'Square',
        landscape: 'Landscape',
        story: 'Story',
        portrait: 'Portrait',
        carousel: 'Carousel',
        commonAspectRatio: 'Common aspect ratio',
    },
};
